import { expressionDefinitionApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CHAT_ASSIGNMENT_CRITERIA_ACTION_TYPE = createNamedActions('chatAssignmentCriteria', {
  GET_CHAT_ASSIGNMENT_CRITERIA_SCHEMA: 'GET_CHAT_ASSIGNMENT_CRITERIA_SCHEMA',
});

export const getChatAssignmentCriteriaSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await expressionDefinitionApi.getChatAssignmentExpressionDefinition();

  return dispatch({
    type: CHAT_ASSIGNMENT_CRITERIA_ACTION_TYPE.GET_CHAT_ASSIGNMENT_CRITERIA_SCHEMA,
    payload: data,
  });
});
